/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Directive, EventEmitter, HostListener, Input, Output} from "@angular/core";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";

import {AigiaLogoutDialogComponent} from "./aigia-logout-dialog.component";

@Directive({
	selector: "[aigia-logout-button]",
})

/**
 *
 */
export class AigiaLogoutDialogDirective {

	@Input() public params = {}

	/**
	 *
	 */
	@Output() public complete = new EventEmitter<any>();

	/**
	 *
	 * @param matDialog
	 */
	constructor(
		private matDialog: MatDialog,
	) {
	}

	/**
	 * todo
	 */
	private Complete(type: string, value: any): void {
		this.complete.emit({type, value});
	}

	/**
	 *
	 * @param target
	 */
	@HostListener("click", ["$event.target"])
	public onClick(target: any): void {

		const dialog: MatDialogRef<any> = this.matDialog.open(AigiaLogoutDialogComponent, {
			minWidth: "30%",
			maxWidth: "90%",
			width: "100vh",
			height: "fit-content",
			panelClass: "dark-card",
			data: {
				content: {
					title: "ログアウト",
					description: "AIGIAからログアウトします。",
					params: this.params
				}
			},
			disableClose: true,
		});

		dialog.afterClosed().subscribe((result: any): void => {
			if (result) {
				this.Complete("", result);
			}
		});
	}

}
